<script>
export default {
  name: 'FiltroTwoLinesPositivo',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/setting-4">
      <g id="setting-4">
        <path
          id="Vector"
          d="M21.3 7.57993H15.72C15.33 7.57993 15.02 7.26993 15.02 6.87993C15.02 6.48993 15.33 6.17993 15.72 6.17993H21.3C21.69 6.17993 22 6.48993 22 6.87993C22 7.26993 21.69 7.57993 21.3 7.57993Z"
          :fill="color"
        />
        <path
          id="Vector_2"
          d="M6.42 7.57993H2.7C2.31 7.57993 2 7.26993 2 6.87993C2 6.48993 2.31 6.17993 2.7 6.17993H6.42C6.81 6.17993 7.12 6.48993 7.12 6.87993C7.12 7.26993 6.8 7.57993 6.42 7.57993Z"
          :fill="color"
        />
        <path
          id="Vector_3"
          d="M10.1399 10.8299C12.3215 10.8299 14.0899 9.06146 14.0899 6.87993C14.0899 4.69841 12.3215 2.92993 10.1399 2.92993C7.95842 2.92993 6.18994 4.69841 6.18994 6.87993C6.18994 9.06146 7.95842 10.8299 10.1399 10.8299Z"
          :fill="color"
        />
        <path
          id="Vector_4"
          d="M21.2999 17.8099H17.5799C17.1899 17.8099 16.8799 17.4999 16.8799 17.1099C16.8799 16.7199 17.1899 16.4099 17.5799 16.4099H21.2999C21.6899 16.4099 21.9999 16.7199 21.9999 17.1099C21.9999 17.4999 21.6899 17.8099 21.2999 17.8099Z"
          :fill="color"
        />
        <path
          id="Vector_5"
          d="M8.28 17.8099H2.7C2.31 17.8099 2 17.4999 2 17.1099C2 16.7199 2.31 16.4099 2.7 16.4099H8.28C8.67 16.4099 8.98 16.7199 8.98 17.1099C8.98 17.4999 8.66 17.8099 8.28 17.8099Z"
          :fill="color"
        />
        <path
          id="Vector_6"
          d="M13.8599 21.0699C16.0414 21.0699 17.8099 19.3014 17.8099 17.1199C17.8099 14.9384 16.0414 13.1699 13.8599 13.1699C11.6784 13.1699 9.90991 14.9384 9.90991 17.1199C9.90991 19.3014 11.6784 21.0699 13.8599 21.0699Z"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>
